const  CONTENT_CONSTANTS = {
  "general": {
    "defaultErrorTitle": "Something went wrong!",
    "sessionExpiredMessage": "Session expired, please reload."
  },
  "newVersion": {
    "newVersionMessage": "Update available. Reloading in 30 seconds.",
    "update": "UPDATE"
  },
  "homepage": {
    "greetingMessage": "Good",
    "cards": {
      "cardError": {
        "title": "Something went wrong",
        "description": "A communication error occurred",
        "reload": "RELOAD"
      },
      "nextMeeting": {
        "title": "My next meeting"
      },
      "learning": {
        "title": "My Learning",
        "allLearning": "All Learning",
        "continueLearning": "Continue Learning",
        "nothingStartedYet": "Nothing started yet",
        "content": "Here you will see and access the content you are currently learning."
      },
      "carServices": {
        "title": "car services",
        "carwash": "CAR WASH",
        "carwashheaderTitle" : "Car Wash",
        "accident"  : "REPORT AN ACCIDENT",
        "carperday"  : "CAR PER DAY",
        "request"  : "MY CAR REQUESTS"
      },
      "timezone": {
        "title": "Work hours",
        "save": "save",
        "clockIn": "CLOCK IN ",
        "clockOut": "CLOCK OUT",
        "total": "Total",
        "hours": "hours",
        "successMessage": "Saved",
        "tooltipMsg": "To edit go to the full application by taping on the app icon",
        "totalHoursErr": "n/a",
        "tooltipClose": "CLOSE",
        "postHourError": "\"To\" hour must be greater then \"From\" hour",
        "postHourFormatError": "Please use HH:MM (00:00-23:59) time format"
      },
      "parking": {
        "title": "Parking"
      },
      "transportation": {
        "title": "Transportation"
      },
      "card5": {
        "title": "card5"
      },
      "cafeteria": {
        "title": "Cafeteria"
      },
      "card8": {
        "title": "card8"
      },
      "jobs": {
        "title": "Amdocs Positions"
      },
      "card10": {
        "title": "card10"
      },
      "travel": {
        "title": "travel"
      },
      "myBenefits": {
        "title": "myBenefits"
      },
      "myRequests": {
        "title": "My requests"
      },
      "travelReceipt": {
        "title": "Travel Receipt"
      },
      "flexSeatEmpty": {
        "title_fLine": "Haven't",
        "title_sLine": "reserved a seat",
        "button": "Book a Seat"
      },
      "flexSeatNonEmpty": {
        "title_fLine": "Your Booked Seat"
      },
      "flexibleSeating" : {
        "title": "Flexible Seating",
      }
    },
    "actions": {
      "callHelpDesk": {
        "title": "Call Help Desk"
      },
      "startItChat": {
        "title": "Start IT Chat"
      },
      "scanQrCode": {
        "title": "Scan QR Code"
      },
      "openRequest": {
        "title": "Open Request"
      }
    },
    "footer": {
      "more": "Apps",
      "needHelp": "I NEED HELP",
      "notifications": "Notifications",
      "myApproval": "My approval",
      "myRequest": "My request"
    }
  },
  "displaySettings": {
    "headerTitle": "Display Settings",
    "title": "Choose 1-4 more cards to display on your home page"
  },
  "settingLobby": {
    "headerTitle": "Settings"
  },
  "accessBridge": {
    "headerTitle": "Access Number",
    "inputPlaceholder": "Search Country"
  },
  "notificationSettings": {
    "headerTitle": "Push Notifications",
    "allowNotifications": "Allow Notifications",
    "notifications": {
      "internal_mobility": "Internal Mobility"
    }
  },
  "scanQr": {
    "redirectLink": {
      "title": "",
      "message": "click REDIRECT if you are not been redirected",
      "buttonText": "REDIRECT"
    },
    "headerTitle": "QR Scan",
    "error": {
      "whiteList": {
        "title": "QR code is not qualified",
        "message": "The QR code you’re trying to scan is not supported by our system"
      },
      "upload": {
        "title": "No camera access",
        "message": "Please upload QR picture"
      },
      "noCameraDetected": {
        "title": "No camera detected",
        "message": "Make sure that your camera is working and site allowed to use camera"
      },
      "tryAgain": "Scan another QR"
    }
  },
  "empDetails": {
    "headerTitle": "Employee Details",
    "call": "Call",
    "work": "Work",
    "mobile": "Mobile",
    "mail": "Email",
    "officeLocation": "Office",
    "country": "Country",
    "department": "Division",
    "employeeId": "Employee ID"
  },
  "employeeSearch": {
    "inputPlaceholder": "Search Employee",
    "noHistory": "Start by typing the name of the employee",
    "endOfResults": "End of results",
    "noResults": "We didn’t find any matches here"
  },
  "empHierarchy": {
    "headerTitle": "Organisation Structure",
    "noManagerFound": "No direct manager found"
  },
  "socialButtons": {
    "skype": "Skype",
    "teams": "Teams",
    "call": "Call",
    "chat": "Chat"
  },
  "newsPage": {
    "headerTitle": "News",
    "noResults": "Nothing new, Come back soon",
    "showMore": "View more news",
    "newsButton": "News"
  },
  "mondayMail" : {
  "mailButton": "MONDAY MAIL"
  },
  "notificationPage": {
    "headerTitle": "Notifications",
    "noResults": "Nothing new, Come back soon",
    "viewLink": "View",
    "viewLinkHe": "פרטים",
    "newsTag": "News",
    "internal": "Internal Mobility"
  },
  "nextMeeting": {
    "noMeeting": "No upcoming meetings",
    "allDay": "All day",
    "join": "Join",
    "popup": {
      "title": "Join meeting",
      "voip": "Open Skype App",
      "dial": "Call bridge"
    }
  },
  "meetingDetails": {
    "headerTitle": "Meeting details",
    "participant": "Participants",
    "joinViaTeams": "Join via Teams",
    "callBridge": "Call Bridge",
    "joinViaSkype": "Join via Skype",
    "joinViaZoom": "Join via Zoom",
    "joinViaWebex": "Join via Webex"
  },
  "notificationPopUp": {
    "title": "\"Clic\" would like to send you notifications",
    "description": "To allow this and only get notifications that matter to you, tap Set Notifications",
    "buttons": {
      "setNotifications": "set notifications",
      "maybeLater": "MAYBE LATER"
    }
  },
  "approveSkypePopUp": {
    "title": "Continue with Skype",
    "description": "Do you have installed skype app on your device?",
    "buttons": {
      "yes": "yes",
      "no": "no"
    }
  },
  "jobsPage": {
    "headerTitle": "Career Opportunities",
    "navigation": {
      "newPositions": "New Positions",
      "managerialJobs": "Managerial Jobs",
      "relocationJobs": "Relocation Jobs"
    },
    "noSearchResults": "We didn’t find any matches here"
  },
  "jobsFilter": {
    "relocation": "Relocation",
    "headerTitle": "Filters",
    "inputPlaceholder": "Type a job/ job number/ keyword",
    "jobsAvailable": "jobs available",
    "location": "Location",
    "country": "Country",
    "countryPlaceholder": "Choose a relocation country",
    "city": "City",
    "allCities": "All Cities",
    "postDate": "Post Date",
    "addSkill": "Add your skills",
    "addSkillPlaceholder": "Add your skill",
    "filter": "FILTER",
    "clear": "CLEAR FILTERS",
    "postOptions": [
      {
        "desc": "Past 24 hours",
        "fq": "+filter(post_date:[NOW-1DAY/DAY TO NOW])",
        "isChecked": false
      },
      {
        "desc": "Past Week",
        "fq": "+filter(post_date:[NOW-7DAY/DAY TO NOW])",
        "isChecked": false
      },
      {
        "desc": "Past Month",
        "fq": "+filter(post_date:[NOW-1MONTH/DAY TO NOW])",
        "isChecked": false
      }
    ],
    "properties": "Properties",
    "propertiesOptions": [
      {
        "desc": "Includes Travel",
        "fq": "-REQ_TRAVEL_t:No Travel",
        "isChecked": false
      },
      {
        "desc": "Manage Others",
        "fq": "+MANAGERIAL_t:Yes",
        "isChecked": false
      }
    ],
    "skills": "Skills",
    "noResults": "no skills"
  },
  "jobFooter": {
    "career": "Career Opportunities",
    "status": "Status and Tracker",
    "saved": "Saved Jobs",
    "faq": "FAQ"
  },
  "jobPage": {
    "headerTitle": "Job details",
    "includeTravel": "Includes Travel",
    "manageOthers": "Manage Others",
    "inOneSentence": "In one sentence",
    "aboutTheJob": "About the job",
    "posted": "Posted",
    "applyJob": "APPLY"
  },
  "aboutJobPage": {
    "headerTitle": "About The Job",
    "organizationLevel1": "Organization Level 1",
    "organizationLevel2": "Organization Level 2",
    "manager": "Manager",
    "talentAcquisition": "Talent Acquisition",
    "requiredTravel": "Required Travel",
    "openToRelocation": "Open to relocation",
    "skill": "Skill",
    "referralBonusReward": "Referral Bonus Reward Amount and currency",
    "whatWillYourJobLook": "What will your job look like?",
    "allYouNeedIs": "All you need is",
    "whyYouWillLoveThisJob": "Why you will love this job",
    "apply": "APPLY"
  },
  "applyJob": {
    "headerTitle": "Apply",
    "applyTo": "apply to",
    "uploadCV": "Upload CV",
    "uploadCVNoticeMsg": "Please make sure the resume will be in Word or PDF format",
    "linkedinPlaceholder": "Enter your Linkedin profile here…",
    "answerQuestionsTitle": "Answer these questions",
    "questions": {
      "employeeFor2Years": {
        "title": "I have been an Amdocs employee for 2 years and above"
      },
      "howLongCurrentAssignment": {
        "title": "How long have you been in your current assignment?",
        "desc": "In cases where you don't meet the eligibility criteria (2 years) you may request an exception from your current manager and HR partner to allow you to apply for a new position.",
        "options": [
          {
            "id": 126160,
            "desc": "Less than a year"
          },
          {
            "id": 126162,
            "desc": "12 – 18 months"
          },
          {
            "id": 126164,
            "desc": "18 – 24 months"
          },
          {
            "id": 126166,
            "desc": "More than 2 years"
          }
        ]
      },
      "relevantCourses": {
        "title": "What relevant courses have you recently studied?"
      },
      "relevantExpInAmdocs": {
        "title": "Do you have any relatives working in the Amdocs Group?"
      },
      "relevantExpDesc": {
        "title": "Specify the name(s) and the relationships with the Amdocs Employee(s)"
      }
    },
    "applyJob": "APPLY",
    "yes": "yes",
    "no": "no",
    "successPopup": {
      "thankYou": "Thank You",
      "haveAppliedFor": "You have applied for",
      "statusAndTracker": "Status and Tracker",
      "close": "CLOSE"
    },
    "mandatory": "Mandatory fields",
    "invalidLinkedin": "invalid linkedin link",
    "uploadCVError": "Please upload the CV file",
    "uploadFailed": "Upload failed",
    "fileTooLargeError": "The CV file is too large, please remove it and make sure the file size is up to 3MB",
    "applicationAlreadyExists": "An open application for this position already exists on your behalf.\nYou will be updated on the progress in due course\n"
  },
  "statusAndTracker": {
    "headerTitle": "Status and Tracker",
    "applyNumbers": "You applied for {0} positions",
    "processEnded": "Process Ended",
    "processSuccess": "You are Hired!!!",
    "thankYouForApplying": "Thank you for applying. While this time it wasn’t a match, please keep your eye out there for other great opportunities.",
    "ContactTalentAcquisition": "Contact talent acquisition",
    "noApplications": "You have not yet applied for any position"
  },
  "referFriendToJob": {
    "headerTitle": "Refer friend to job",
    "subTitle": "Please provide the information below",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "countryRegion": "Country / Region",
    "send": "SEND",
    "addResume": "Add resume",
    "addResumeText": "Accepted resume file types: DOCX, PDF, Image and text",
    "chooseFile": "Choose File",
    "mandatory": "Mandatory field",
    "emailErr": "Invalid email address",
    "phoneErr": "Invalid phone number",
    "attachment": "Attachment",
    "mandatoryFile": "Please upload the CV file",
    "thanks": "Thank You",
    "referAJob": "You refered a job",
    "errorTitle": "Something went wrong",
    "errorMsg": "A communication error occurred. You can either try again or to go back to the main page.",
    "uploadFailed": "Upload failed",
    "personExistsError": "The person you are trying to refer already exists on this job. Please refer this person to another job.",
    "personOwnedError": "The person you are trying to refer is currently owned by another employee. You may not submit them at this time."
  },
  "shareWithFriend": {
    "headerTitle": "Share with Amdocs friend",
    "subTitle": "Please provide the information below",
    "jobTitle": "Job title",
    "name": "Name",
    "namePlaceholder": "Choose an Amdocs employee",
    "emailNotice": "Please note that the email can be sent only to Amdocs employee",
    "send": "Send",
    "thankYou": "Thank You",
    "theJobSent": "The job was sent to your friend",
    "mandatory": "Mandatory field",
    "close": "Close",
    "errorTitle": "Something went wrong",
    "errorMsg": "A communication error occurred. You can either try again or to go back to the main page. ",
    "successMsg": "The job was sent to your friend",
    "closePopup": "CLOSE"
  },
  "savedJobs": {
    "headerTitle": "Saved Jobs",
    "noSavedJobs": "Everything is quite here"
  },
  "career": {
    "title": "Career Opportunities",
    "nextOpportunityTitle": "Your next opportunity starts here",
    "nextOpportunitySubTitle": "open roles",
    "youHave": "You have",
    "inProcess": "applications in process",
    "statusBtn": "VIEW STATUS",
    "explore": "EXPLORE",
    "shareWith": "Share with amdocs friend",
    "refer": "Refer friend to job"
  },
  "onBoarding": {
    "step1": {
      "hi": "Hi {0}",
      "title": "Welcome to CLIC",
      "desc": "Your smart entry-point for all your needs in one place."
    },
    "step2": {
      "title": "My upcoming meeting",
      "text": "Swipe to see your upcoming meetings"
    },
    "step3": {
      "title": "Need help?",
      "text": "Here you can chat with IT support or select 'open request' to open a ticket"
    },
    "step4": {
      "title": "Find your friend",
      "text": "You can easily search for your colleague at any time"
    },
    "step5": {
      "title": "Amdocs news",
      "text": "Here you can stay up to date on Amdocs News."
    },
    "buttons": {
      "next": "NEXT",
      "finish": "FINISH",
      "skip": "SKIP"
    }
  },
  "clickNPlay": {
    "title": "How fast can you click?",
    "button": "START PLAYING",
    "myPersonalBest": "My personal best: ",
    "playAgain": "PLAY AGAIN"
  },
  "parkingPage": {
    "headerTitle": "Parking"
  },
  "clickGame": {
    "headerTitle": "Clic & Win",
    "finishText": {
      "option1": {
        "title": "GOOD JOB!",
        "text": "You are almost there!"
      },
      "option2": {
        "title": "TRY AGAIN",
        "text": "You can do better"
      },
      "option3": {
        "title": "TRY AGAIN",
        "text": "You got really close"
      },
      "record": {
        "title": "NEW RECORD",
        "text": "TRY TO BEAT OTHERS!"
      }
    },
    "footer": {
      "howManyTimes": "HOW MANY TIMES",
      "canYou": "CAN YOU",
      "in": "IN",
      "5": "5",
      "sec": "SEC."
    }
  },
  "itAccessory": {
    "headerTitle": "Pick up your IT accessory",
    "contentTitle": "Congrats!",
    "contentBody": "You are entitled to receive a new webcam",
    "contentDescBody": "The webcam can be collected from Amdocs sites only",
    "dropdownDesc": "If your site isn’t listed below it will be included in the next phase of distribution. Stay tuned for more updates",
    "moreInfoDesc": "For more information, we invite you to \nread ",
    "moreInfoDesc2": " or to chat with ",
    "supportUrlDesc": "IT Support",
    "FAQUrlDesc": "FAQ",
    "sitesDropdown": {
      "placeholder": "Select your site",
      "label": "Pickup location"
    }
  },
  "lotteryPopup": {
    "title": "Congrats!",
    "text": "You are part of the PING raffle - stay tuned",
    "button": "GO TO HOME PAGE"
  },
  "profilePage": {
    "myProfile": "My Profile",
    "fields": {
      "id": "ID",
      "org": "Org",
      "email": "Email",
      "Office": "Office"
    },
    "orgTitle": "Org. Chart"
  },
  "calendar": {
    "headerTitle": "Amdocs Calendar",
    "countriesLabel": "country"
  },
  "myApproval": {
    "headerTitle": "My Approval",
    "title": "Pending your approval",
    "subtitle": "Displaying approvals created since July 2022"
  },
  "myApprovalList": {
    "tz": "Time zone",
    "olf": "OLF",
    "snow": "Service Request",
    "timeZone": "Timezone"
  },
  "myApprovalCard": {
    "week": "Week",
    "period": "Period",
    "created": "Created",
    "indicators": "Indicators",
    "id": "ID",
    "presence": "Presence",
    "description": "Description",
    "approveOnDesktopOnly": "Approve on desktop only",
    "readNotes": "Read notes",
    "notes": "Notes",
    "viewMore": "View more",
    "sendingEmail": "Sending Email",
    "sendAgain": "Send again",
    "emailSent": "Email sent",
    "emailDeliveryFailed": "Email delivery failed",
    "tryAgain": "Try again",
    "rejected": "Rejected",
    "approved": "Approved",
    "approvalSubmitted": "Approval Submitted",
    "rejectionSubmitted": "Rejection Submitted"
  },
  "myApprovalDetails": {
    "comments": "Comments ({0})",
    "reject": "Reject",
    "approve": "Approve",
    "fullDetails": "Full Details",
    "approvers": "Approvers",
    "emailMe": "Email me",
    "cancel": "Cancel",
    "approvalFailed": "Approval failed",
    "rejectionFailed": "Rejection failed",
    "acknowledgeFailed": "Acknowledge failed",
    "eligibleForReimbursement": "Eligible for Reimbursement",
    "requiredPurchase": "Required purchase",
    "addComment": "Add Comment",
    "save": "Save"
  },
  "myApprovalError": {
    "errorText": "One or more actions couldn't be perfomed ",
    "retry": "Retry"
  },
  "guestReservation": {
    "headerTitle": "Guest Reservation",
    "hostdetailsLabel": "Host Details",
    "hostMobileLabel": "Host Mobile Number",
    "siteInfoLabel": "Site Information",
    "countriesLabel": "Country",
    "siteLabel": "Site",
    "guestdetailsLabel": "Guest Details",
    "guestNameLabel": "Guest Name",
    "guestEmailLabel": "Guest Email",
    "guestMobileLabel": "Guest Mobile Number",
    "guestArrivalLabel": "Arrival Date and Time",
    "guestDepartureLabel": "Departure Date and Time",
    "guestLicenseLabel": "License Number",
    "mandatory": "Mandatory field",
    "next": "Next",
    "update": "Update",
    "cancel": "Cancel",
    "success": "Form Submitted Successfully",
    "sure": "Are you sure you want to cancel this reservation?",
    "no":"No",
    "cancelit":"Yes, Cancel It!",
    "required": "This field is required",
    "mobileLength": "Cell phone should be 10-15 digits",
    "invalidName": "Name should be in english characters",
    "invalidEmail": "Please enter mail format: x@y.z",
    "arrivalRequired": "Guest Arrival date and time is required.",
    "departureRequired": "Guest Arrival date and time is required.",
    "licenceLength": "License plate should be upto 8 digits"
  },
  "learningPopup": {
    "title": "Learn on the go with Learning Zone!",
    "button": "CHECK IT OUT NOW"
  },
  "dbupgrade": {
    "title": "Please note TZ related items will be unavailable for the next few days due to Oracle upgrade",
    "msg" : "Thanks for your patience.",
    "button": "OK"
  },

   "carWash": {
    "headerTitle": "Car Wash",
    "carWashdetailsLabel": "Parking details",
    "carWashsiteLabel": "Site",
    "parkingNameLabel": "Parking name",
    "parkingDescLabel": "Parking spot",
    "accessDetailsLabel": "Access details",
    "keyLocationLabel": "Key location",
    "carCodeLabel": "Car code",
    "descPlaceHolder": "Type your description here",
    "yourPreLabel": "Your preferences",
    "washTrunkLabel": "Would you like the trunk cleaned?",
    "commentsLabel": "Comments (Hebrew)",
    "commentsPlaceHolder": "Type your comment here",
    "addPicLabel": "Would you like to add pictures?",
    "uploadPicLabel": "Click here to upload or drop pictures here",
    "returnByLabel": "Return by",
    "confirmLabel": "I confirm that Amdocs is not responsible for valuable items left in the car.",
    "required": "This field is required",
    "clicHere": "Click here",
    "uploadDesc": " to upload",
    "confirmBtn": "SUBMIT",
    "cancelBtn": "CANCEL",
    "success": "Ticket Submitted Successfully",
    "carWashNote": "Note: This service is limited to company cars only",
  },
  "carPerDay": {
    "headerTitle": "Car Per Day",
    "carPerDaysiteLabel": "Site",
    "carCategory": "Car Category",
    "pickupDate": "Pick up Date",
    "returnDate": "Return Date",
    "confirmBtn": "SUBMIT",
    "cancelBtn": "CANCEL",
    "popupbutton": " אישור תנאים",
    "confirmLabel": "I acknowledge that I have read contract and I agree to the",
    "termsofContract": "Terms of Contract",
    "terms": "תנאי השאלת רכב מטרת השרות הינה לתת מענה משלים לפתרונות תחבורה חלופיים (כגון: תחבורה ציבורית, שאטלים, CARPOOL ).\n\n· השימוש בשרות מיועד לעובדי חברה בלבד.\n\n· הנהיגה מותרת לעובד בלבד ובהתאם לנוהל הרכב. נהג נוסף שאינו מוגדר כנהג הדורש ליווי ברכב יורשה לנהוג ברכב רק כאשר הנהג המורשה נוכח ברכב. חובה להגיע לקבלת הרכב עם רשיון נהיגה בתוקף וכרטיס עובד.\n\nהשאלת הרכב, תנאי חישוב העלות והשתתפות עצמית בנזק לרכב:\n\n· השאלת הרכב תוגבל לעד 14 יום ברצף.\n\n· במידה ותהיה חריגה מעבר ל 250 ק\"מ ביום, העובד יישא בעלות נוספת של 25 אגורות לק\"מ.\n\n· עלות הדלק תחושב בהתאם לכמות הק\"מ שבוצע בפועל, חלקי הצריכה הממוצעת כפי שנקבע במחלקת התחבורה על פי סוג הרכב, כפול עלות הדלק נכון לתחילת החודש הקלאנדרי (בהתאמה ליום קבלת הרכב).\n\n· במקרה של נזק לרכב - תשלום השתתפות עצמית יחושב החל מהנזק הראשון ועד סכום של 1300₪.\n\n· כל דוח עירייה / משטרה / או אחר יוסב על שם העובד.\n\n· תנאים ועלויות יעודכנו מעת לעת.\n\n· החברה תשמור לעצמה את הזכות לא לאפשר שימוש בשירות בהתאם לשיקול דעתה (עיקולים, תאונות חוזרות, התנהלות שאינה תואמת את ערכי החברה וכו').\n\nזמינות רכבים: ניתן להזמין רכב בהתאם לזמינות ועד לתאריך החזרה של עד שלושה שבועות.\n\nזמינות הרכבים הינה בהתאם למופיע באפליקציה, אמדוקס אינה מחוייבת להקצות כמות מסוימת של רכבים.\n\nקבלת הרכב והחזרתו:\n\n· קבלת הרכב והחזרתו תתבצע בימי חול בלבד, באותו הסניף ממנו נלקח הרכב;\n\n· קבלת הרכב תתאפשר בין השעות 14:00-16:00 בלבד.\n\n· החזרת הרכב תתאפשר בין השעות 8:00 - 11:00 בלבד.\n\n· כל איחור בהחזרת הרכב יגרור חיוב עבור יום נוסף.\n\nביטול הזמנות:\n\n· עד 24 שעות לפני מועד קבלת הרכב ללא חיוב (עד שעה 14:00).\n\n· פחות מ-24 שעות ממועד קבלת הרכב – חיוב עבור יום אחד.\n\n· ביטול במהלך תקופת ההשאלה – חיוב עבור יום אחד (יום הביטול).\n\n· ידוע לי שהעלות המפורטת במסמך/נוהל הרכב ובאפליקציה תחויב דרך תלוש השכר.\n\nהנני מאשר שקראתי את נוהל הרכב של החברה המתפרסם בפורטל החברה ואת האמור במסמך זה ומתחייב לפעול על פיהם, ידוע לי כי הנוהל והמסמך מתעדכנים מעת לעת ובאחריותי לעקוב אחרי העדכונים אלו ולפעול על פי האמור בהם.",
    "success": "Ticket Submitted Successfully"
  },
    "carAccident": {
    "headerTitle": "Car Accident",
    "heading1st": "דיווח תאונה",
    "WasPoliceinvolved": "אנא בחרו את סוג הארוע",
    "heading2nd": "פרטים כלליים",
    "pickupDate": "Pick up Date",
    "returnDate": "Return Date",
    "confirmBtn": "SUBMIT",
    "cancelBtn": "CANCEL",
    "popupbutton": " אישור תנאים",
    "confirmLabel": "I acknowledge that I have read contract and I agree to the",
    "termsofContract": "Terms of Contract",
    "terms": "תנאי השאלת רכב מטרת השרות הינה לתת מענה משלים לפתרונות תחבורה חלופיים (כגון: תחבורה ציבורית, שאטלים, CARPOOL ).\n\n· השימוש בשרות מיועד לעובדי חברה בלבד.\n\n· הנהיגה מותרת לעובד בלבד ובהתאם לנוהל הרכב. נהג נוסף שאינו מוגדר כנהג הדורש ליווי ברכב יורשה לנהוג ברכב רק כאשר הנהג המורשה נוכח ברכב. חובה להגיע לקבלת הרכב עם רשיון נהיגה בתוקף וכרטיס עובד.\n\nהשאלת הרכב, תנאי חישוב העלות והשתתפות עצמית בנזק לרכב:\n\n· השאלת הרכב תוגבל לעד 14 יום ברצף.\n\n· במידה ותהיה חריגה מעבר ל 250 ק\"מ ביום, העובד יישא בעלות נוספת של 25 אגורות לק\"מ.\n\n· עלות הדלק תחושב בהתאם לכמות הק\"מ שבוצע בפועל, חלקי הצריכה הממוצעת כפי שנקבע במחלקת התחבורה על פי סוג הרכב, כפול עלות הדלק נכון לתחילת החודש הקלאנדרי (בהתאמה ליום קבלת הרכב).\n\n· במקרה של נזק לרכב - תשלום השתתפות עצמית יחושב החל מהנזק הראשון ועד סכום של 1300₪.\n\n· כל דוח עירייה / משטרה / או אחר יוסב על שם העובד.\n\n· תנאים ועלויות יעודכנו מעת לעת.\n\n· החברה תשמור לעצמה את הזכות לא לאפשר שימוש בשירות בהתאם לשיקול דעתה (עיקולים, תאונות חוזרות, התנהלות שאינה תואמת את ערכי החברה וכו').\n\nזמינות רכבים: ניתן להזמין רכב בהתאם לזמינות ועד לתאריך החזרה של עד שלושה שבועות.\n\nזמינות הרכבים הינה בהתאם למופיע באפליקציה, אמדוקס אינה מחוייבת להקצות כמות מסוימת של רכבים.\n\nקבלת הרכב והחזרתו:\n\n· קבלת הרכב והחזרתו תתבצע בימי חול בלבד, באותו הסניף ממנו נלקח הרכב;\n\n· קבלת הרכב תתאפשר בין השעות 14:00-16:00 בלבד.\n\n· החזרת הרכב תתאפשר בין השעות 8:00 - 11:00 בלבד.\n\n· כל איחור בהחזרת הרכב יגרור חיוב עבור יום נוסף.\n\nביטול הזמנות:\n\n· עד 24 שעות לפני מועד קבלת הרכב ללא חיוב (עד שעה 14:00).\n\n· פחות מ-24 שעות ממועד קבלת הרכב – חיוב עבור יום אחד.\n\n· ביטול במהלך תקופת ההשאלה – חיוב עבור יום אחד (יום הביטול).\n\n· ידוע לי שהעלות המפורטת במסמך/נוהל הרכב ובאפליקציה תחויב דרך תלוש השכר.\n\nהנני מאשר שקראתי את נוהל הרכב של החברה המתפרסם בפורטל החברה ואת האמור במסמך זה ומתחייב לפעול על פיהם, ידוע לי כי הנוהל והמסמך מתעדכנים מעת לעת ובאחריותי לעקוב אחרי העדכונים אלו ולפעול על פי האמור בהם."
  },

  "popUp":{
    "watingListTitle": "You are currently on a Waiting List",
    "watingListText": "Please confirm or cancel request",
    "confirmPopup": "CONFIRM",
    "bookedTitle": "Car wash is fully booked today",
    "bookedText": "Please Try Again Later",
    "closeBtn": "CLOSE",
    "reqCancelTitle": "Request was cancelled",
    "cancelBtn": "Cancel",
  },

  "carService":{
    "carService" : "Car Services",
    "carPerDay" : "Car Per Day",
    "carWash" : "Car Wash",
    "carAccident" : "Report an Accident",
    "scheduleService" : "Schedule a Service",
    "vehicleFault" : "Vehicle Fault",
    "tempUnavailable" : "Temporarily Unavailable",
    "myCarRequests" : "My Car Requests",
    "contactUs" : "Contact Us",
    "transportation" : "Transportation: Available via Microsoft Teams",
    "callCenter" : "24/7 Call Center:",
    "phone" : "09-776-3800",
    "landLine" : "1-700-701-565",
    "acceptedRequests": "Car wash requests accepted until 12:00 only.",
    "tryAgainLater": "Please Try Again Later."
  },

  "vehicleFault":{
    "label1": "סניף",
    "label2": "סוג התקלה",
    "label3": "אחר - פירוט",
    "label4": "הערות",
    "cancelBtn": "בטל",
    "confirmBtn": "שלח",
    "popupTitleLine1": "תודה על פנייתך",
    "popupTitleLine2": "נציגי ח.י.ל יצרו עמך קשר בהקדם",
    "popupCloseBtn": "סגור",
    "errorMessage": "This field is required"
  },

  "scheduleService":{
    "label1": "סניף",
    "label2":"סוג הטיפול",
    "label3": "תאריך הטיפול",
    "label4": "הערות",
    "cancelBtn": "בטל",
    "confirmBtn": "שלח",
    "popupTitleLine1": "קריאת השירות נקלטה במערכת.",
    "popupTitleLine2": "יש למסור את הרכב ביום הטיפול עד",
    "popupTitleLine3": " השעה 10:00.",
    "popupCloseBtn": "סגור",
    "bookedTitle": "Unable to schedule a new service",
    "errorMessage": "This field is required"
  }

};

  export default CONTENT_CONSTANTS;
